"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("reshow-runtime/helpers/objectSpread2"));
var _classLib = require("class-lib");
var _Label = _interopRequireDefault(require("../molecules/Label.js"));
var _jsxRuntime = require("react/jsx-runtime");
var Ribbon = function Ribbon(props) {
  var classes = (0, _classLib.mixClass)(props.className, "ribbon");
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Label["default"], (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, props), {}, {
    clssName: classes
  }));
};
var _default = exports["default"] = Ribbon;
module.exports = exports.default;